/**
  =========================================================
  * Material Dashboard 2 React - v2.2.0
  =========================================================

  * Product Page: https://www.creative-tim.com/product/material-dashboard-react
  * Copyright 2023 Creative Tim (https://www.creative-tim.com)

  Coded by www.creative-tim.com

  =========================================================

  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  */

// @mui material components
import { Box, Button, Grid } from "@mui/material";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import axios from "axios";
import PlaceIcon from '@mui/icons-material/Place';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import TimelineItem from "examples/Timeline/TimelineItem";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MDAvatar from "components/MDAvatar";
import burceMars from "assets/images/dummy-logo.png";

function OrdersOverview() {
  const [departments, setDepartments] = useState([]);
  const accessData = useSelector((state) => state.auth.accessData);

  useEffect(() => {
    const fetchYojnaDepartment = async () => {
      const access_token =
        localStorage.getItem("access_token") || sessionStorage.getItem("access_token");
      const user_role = localStorage.getItem("user_role") || sessionStorage.getItem("user_role");

      if (!access_token || !user_role) {
        console.error("❌ Access token or Role ID missing!");
        return;
      }

      try {
        const response = await axios.get(
          "https://telelawmh.in/apiv2collectorapp/public/api/yojna-department",
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
              "Content-Type": "application/json",
              RoleID: user_role,
            },
          }
        );

        console.log("✅ API Response:", response.data.departments);
        setDepartments(response.data.departments); // ✅ Store data in state
      } catch (error) {
        console.error("❌ API Error:", error.response ? error.response.data : error.message);
      }
    };

    fetchYojnaDepartment();
  }, []);
  return (
    <Card sx={{ height: "100%", maxHeight: 625, overflow: "hidden" }}>
      <MDBox pt={3} px={3}>
        {/* <MDTypography variant="h3" fontWeight="medium">
          <PlaceIcon />  
        </MDTypography> */}
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDAvatar src={burceMars} alt="profile-image" size="xl" shadow="sm" />
          </Grid>
          <Grid item>
            <MDTypography variant="h2" fontWeight="medium">
              तालुके
            </MDTypography>
          </Grid>
        </Grid>
        <Box
          sx={{
            maxHeight: 550,
            overflowY: "auto",
            mt: 2,
            pr: 1.5,
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#a7d2f7",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#555",
            },
          }}
        >
          <MDBox sx={{ mb: 3 }}>
            {accessData?.talukas?.length > 0 ? ( // ✅ Check if talukas exist before mapping
              accessData.talukas.map((taluka, index) => (
                <Button
                  key={taluka.taluka_id} // ✅ Correct key placement
                  variant="contained"
                  fullWidth
                  sx={{
                    my: 1,
                    py: 3,
                    fontSize: "1.2rem",
                    color: "white",
                    background: "linear-gradient(135deg, #a3bded 10%, #6991c7 100%)",
                    transition: "all 0.3s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(135deg, #6991c7 10%, #a3bded 100%)",
                    },
                  }}
                >
                  <MDTypography variant="h4" fontWeight="medium">
                    {taluka.taluka_title} {/* ✅ Corrected text display */}
                  </MDTypography>
                </Button>
              ))
            ) : (
              <MDTypography variant="h6" color="textSecondary">
                ❌ No data available.
              </MDTypography>
            )}
          </MDBox>
        </Box>
      </MDBox>
    </Card>
  );
}

export default OrdersOverview;
